module.exports = __webpack_public_path__ + "static/media/20.5b90f8e4.png";